import {
  IconBranchOffices,
  IconCheckouts,
  IconCompanies,
  IconDashboard,
  IconDocument1,
  IconFlexPools,
  IconInbox,
  IconJobs,
  IconOperation,
  IconPlanning,
  IconProject,
  IconSetting2,
  IconToday2,
  IconUsers,
} from 'assets/img';
import { paths } from 'ogp/paths';
import { useTranslation } from 'react-i18next';
import { getCheckoutsArchiveDefaultFilters } from '../administration/shared';

export const useSidebarItems = () => {
  const { t } = useTranslation('ogp-screen-specific');

  return [
    {
      key: 'planning',
      name: t('sidebar.planning'),
      children: [
        {
          ...paths.Dashboard,
          label: t('sidebar.dashboard'),
          icon: <IconDashboard />,
        },
        {
          ...paths.ShiftPlanning,
          label: t('sidebar.shift_planning'),
          icon: <IconPlanning />,
        },
        {
          ...paths.Availability,
          label: t('sidebar.availability'),
          icon: <IconToday2 />,
        },
        {
          ...paths.Workforce,
          label: t('sidebar.workforce'),
          icon: <IconOperation />,
        },
        {
          ...paths.Projects,
          label: t('sidebar.project_planning'),
          icon: <IconProject />,
        },
        {
          ...paths.WorkTemplates,
          label: t('sidebar.work_templates'),
          icon: <IconJobs />,
        },
        {
          ...paths.FlexPools,
          label: t('sidebar.flex_pools'),
          icon: <IconFlexPools />,
        },
      ],
    },
    {
      key: 'administration',
      name: t('sidebar.administration'),
      children: [
        {
          ...paths.CheckoutsInbox,
          label: t('sidebar.checkouts_inbox'),
          icon: <IconInbox />,
        },
        {
          ...paths.CheckoutsArchive,
          path: `${paths.CheckoutsArchive.path}${getCheckoutsArchiveDefaultFilters()}`,
          label: t('sidebar.checkouts_archive'),
          icon: <IconCheckouts />,
        },
      ],
    },
    {
      key: 'management',
      name: t('sidebar.management'),
      children: [
        {
          ...paths.Company,
          label: t('sidebar.company'),
          icon: <IconCompanies />,
        },
        {
          ...paths.BranchOffices,
          label: t('sidebar.branch_offices'),
          icon: <IconBranchOffices />,
        },
        {
          ...paths.Departments,
          label: t('sidebar.departments'),
          icon: <IconBranchOffices />,
        },
        {
          ...paths.Users,
          label: t('sidebar.users'),
          icon: <IconUsers />,
        },
        {
          ...paths.Legal,
          label: t('sidebar.legal_documents'),
          icon: <IconDocument1 />,
        },
      ],
    },
    {
      key: 'settings',
      name: t('sidebar.settings'),
      children: [
        {
          ...paths.Settings,
          label: t('sidebar.settings'),
          icon: <IconSetting2 />,
        },
      ],
    },
  ] as const;
};
